import { render, staticRenderFns } from "./editorPopoverOptionButton.vue?vue&type=template&id=54e9688d&scoped=true&"
import script from "./editorPopoverOptionButton.vue?vue&type=script&lang=js&"
export * from "./editorPopoverOptionButton.vue?vue&type=script&lang=js&"
import style0 from "./editorPopoverOptionButton.vue?vue&type=style&index=0&id=54e9688d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e9688d",
  null
  
)

export default component.exports